var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile--mockup"},[_c('div',[_c('iframe',{attrs:{"src":_vm.src,"title":_vm.title,"id":"activity-preview"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }